module.exports = __webpack_public_path__ + "img/max13.91be9d61.png";